module.exports = __webpack_public_path__ + "img/logo.9021e93e.png";